// extracted by mini-css-extract-plugin
export default {"forStore__store":"ForStore_forStore__store__m91TJ","forStore__store__img":"ForStore_forStore__store__img__SWvMV"};